import { DependencyLifeTime, Injectable } from "@miracledevs/paradigm-web-di";
import { ContextCollection } from "../../../contexts/DependencyContext";
import { ApiClientBase } from "./ApiClientBase";

@Injectable({ collection: ContextCollection, lifeTime: DependencyLifeTime.Singleton })
export class IndicatorsApiClient extends ApiClientBase
{
    constructor()
    {
        super(process.env.REACT_APP_INDICATORS_API_URL);
    }
}